import React from "react";
import { useRouteError } from "react-router-dom";
function Error() {
  const err = useRouteError();
  return (
    <>
      <h1>Error: {err.message}</h1>
      <pre>
        {err.status} - {err.statusText}
      </pre>
    </>
  );
}

export default Error;
